import React from 'react'
import { GridElement } from '..'
import { LoomCard } from '../../components'

export const LoomGridCard: React.FC<GridElement> = props => {
    const { ShowBusinessName, ShowPhoneNumber, ShowAddress, ShowHours, ShowDirections, SiteId } = props.value

    return (
        <LoomCard
            showBusinessName={ShowBusinessName === '1'}
            showPhoneNumber={ShowPhoneNumber === '1'}
            showAddress={ShowAddress === '1'}
            showHours={ShowHours === '1'}
            showDirections={ShowDirections === '1'}
            siteId={SiteId}
        />
    )
}
